var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { appendStReportsSalesOrderDetailsQuerySegment, normalizeStReportsOrdersApiPayload, ST_ORDER_DETAILS_DEFAULT_ROWS_PER_PAGE, stReportsSalesOrderDetailsToFlatQueryParams, } from "../../component/model/STOrderDetailsModel";
import store from "../../reduxStore/store";
import { isLoading, isAPIServerError } from "../behaviorSubjectService";
import { apiCallService, decryptData, encryptData } from "../commonServices";
import { logClientRuntimeError } from "../clientErrorLog";
import { splitSTOrderDetailsOrdersIntoLegacySlices } from "../stReportUnifiedOrderMapper";
import axios from "axios";
import { TOASTER_TIMEOUT } from "../../component/Constant";
/** Default `pageSize` for GET `data=59` — fixed at 50 (same as Sales Order Details grid). */
export var ST_ORDER_DETAILS_DEFAULT_LIST_PAGE_SIZE = ST_ORDER_DETAILS_DEFAULT_ROWS_PER_PAGE;
/** Rolling window for Sales Order Details catalog-style loads: `dateFrom` = today − 30 days, `dateTo` = today (`yyyy-MM-dd`). */
export function getDefaultWideDateRangeForSTOrderDetails() {
    try {
        var pad_1 = function (n) { return String(n).padStart(2, "0"); };
        var end = new Date();
        end.setHours(0, 0, 0, 0);
        var start = new Date(end);
        start.setDate(end.getDate() - 30);
        var iso = function (d) { return "".concat(d.getFullYear(), "-").concat(pad_1(d.getMonth() + 1), "-").concat(pad_1(d.getDate())); };
        return { dateFrom: iso(start), dateTo: iso(end) };
    }
    catch (error) {
        logClientRuntimeError("getDefaultWideDateRangeForSTOrderDetails", error);
        var pad_2 = function (n) { return String(n).padStart(2, "0"); };
        var end = new Date();
        end.setHours(0, 0, 0, 0);
        var iso = function (d) { return "".concat(d.getFullYear(), "-").concat(pad_2(d.getMonth() + 1), "-").concat(pad_2(d.getDate())); };
        return { dateFrom: iso(end), dateTo: iso(end) };
    }
}
/** Last 30 calendar days ending today — useful for ST Reports default presets (`DateRangePickerBL`); not the Redux full-catalog window. */
export function getLast30DaysDateRangeForSTOrderDetails() {
    try {
        var pad_3 = function (n) { return String(n).padStart(2, "0"); };
        var end = new Date();
        end.setHours(0, 0, 0, 0);
        var start = new Date(end);
        start.setDate(end.getDate() - 29);
        var iso = function (d) { return "".concat(d.getFullYear(), "-").concat(pad_3(d.getMonth() + 1), "-").concat(pad_3(d.getDate())); };
        return { dateFrom: iso(start), dateTo: iso(end) };
    }
    catch (error) {
        logClientRuntimeError("getLast30DaysDateRangeForSTOrderDetails", error);
        var pad_4 = function (n) { return String(n).padStart(2, "0"); };
        var end = new Date();
        end.setHours(0, 0, 0, 0);
        var iso = function (d) { return "".concat(d.getFullYear(), "-").concat(pad_4(d.getMonth() + 1), "-").concat(pad_4(d.getDate())); };
        return { dateFrom: iso(end), dateTo: iso(end) };
    }
}
function parseShopRegistrationDateFromBaseData(value) {
    if (value == null || value === "") {
        return null;
    }
    var raw = String(value).trim();
    if (!raw) {
        return null;
    }
    var isoMatch = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
    if (isoMatch) {
        var d = new Date(Number(isoMatch[1]), Number(isoMatch[2]) - 1, Number(isoMatch[3]));
        if (!Number.isNaN(d.getTime())) {
            d.setHours(0, 0, 0, 0);
            return d;
        }
    }
    var parsed = new Date(raw);
    if (!Number.isNaN(parsed.getTime())) {
        parsed.setHours(0, 0, 0, 0);
        return parsed;
    }
    return null;
}
/** `shopRegistrationDate` from GET `data=1` (`baseData` root). */
function getShopRegistrationDateFromBaseData(baseData) {
    var _a;
    if (baseData == null || typeof baseData !== "object") {
        return null;
    }
    var record = baseData;
    return parseShopRegistrationDateFromBaseData((_a = record.shopRegistrationDate) !== null && _a !== void 0 ? _a : record.ShopRegistrationDate);
}
/**
 * All Time: `dateFrom` = `baseData.shopRegistrationDate`, `dateTo` = today.
 * Uses Redux `baseData` from `data=1`; refreshes `data=1` only when the date is missing.
 */
export function getAllTimeDateRangeForSTOrderDetails() {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var endDate, startDate, fresh, error_1;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    endDate = new Date();
                    endDate.setHours(0, 0, 0, 0);
                    startDate = null;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    startDate = getShopRegistrationDateFromBaseData((_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.baseData);
                    if (!!startDate) return [3 /*break*/, 3];
                    return [4 /*yield*/, salesRepBaseDataService()];
                case 2:
                    fresh = _b.sent();
                    startDate = getShopRegistrationDateFromBaseData(fresh);
                    _b.label = 3;
                case 3:
                    if (!startDate) {
                        logClientRuntimeError("getAllTimeDateRangeForSTOrderDetails", new Error("baseData.shopRegistrationDate missing from data=1"));
                        startDate = new Date(endDate);
                        startDate.setFullYear(startDate.getFullYear() - 10);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _b.sent();
                    logClientRuntimeError("getAllTimeDateRangeForSTOrderDetails", error_1);
                    startDate = new Date(endDate);
                    startDate.setFullYear(startDate.getFullYear() - 10);
                    return [3 /*break*/, 5];
                case 5:
                    if (startDate.getTime() > endDate.getTime()) {
                        return [2 /*return*/, { startDate: endDate, endDate: endDate }];
                    }
                    return [2 /*return*/, { startDate: startDate, endDate: endDate }];
            }
        });
    });
}
/** One Sales Order Details API page (`stReportsSalesOrderDetailsRequest.*`), decrypted. */
function fetchSTOrderDetailsOrdersPage(dateFrom, dateTo, pageNumber, pageSize) {
    return __awaiter(this, void 0, void 0, function () {
        var req, url, serviceCallResponse, norm, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    req = {
                        dateFrom: dateFrom,
                        dateTo: dateTo,
                        dateField: "",
                        pageNumber: pageNumber,
                        pageSize: pageSize,
                        activeTab: "All",
                    };
                    url = baseUrlWithCommonParams() + appendStReportsSalesOrderDetailsQuerySegment(req);
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (!(serviceCallResponse && typeof serviceCallResponse === "string")) return [3 /*break*/, 3];
                    return [4 /*yield*/, decryptData(serviceCallResponse)];
                case 2:
                    serviceCallResponse = _a.sent();
                    _a.label = 3;
                case 3:
                    norm = normalizeStReportsOrdersApiPayload(serviceCallResponse);
                    if (!norm) {
                        return [2 /*return*/, null];
                    }
                    return [2 /*return*/, norm.Orders];
                case 4:
                    error_2 = _a.sent();
                    logClientRuntimeError("fetchSTOrderDetailsOrdersPage", error_2);
                    return [2 /*return*/, null];
                case 5: return [2 /*return*/];
            }
        });
    });
}
var parsedAuthentication = "";
export function getLoggedInRepDetails() {
    var loggedInRepData = store.getState().salesRepData.loggedInRepDetails;
    return loggedInRepData;
}
export function displaySnackbarErrMsg() {
    isAPIServerError.next(true);
    isLoading.next(false);
    setTimeout(function () {
        isAPIServerError.next(false);
    }, TOASTER_TIMEOUT);
}
export function getLoggedInRepDetailsFromSession() {
    var authenticationDetails = sessionStorage.getItem("Authorization");
    // Unicode-safe atob for different languages (Japanese, Chinese, etc.)
    parsedAuthentication = authenticationDetails ? JSON.parse(decodeURIComponent(escape(atob(authenticationDetails)))) : "";
    return parsedAuthentication;
}
/** Session token first; fall back to Shopify embed props when login drawer is bypassed (local dev). */
export function getRepCustomerIdAndNameForApi() {
    var _a, _b, _c, _d;
    var session = getLoggedInRepDetailsFromSession();
    var fromStore = getLoggedInRepDetails();
    var customerId = String((_b = (_a = session === null || session === void 0 ? void 0 : session.CustomerId) !== null && _a !== void 0 ? _a : fromStore === null || fromStore === void 0 ? void 0 : fromStore.customerId) !== null && _b !== void 0 ? _b : "").trim();
    var customerName = String((_d = (_c = session === null || session === void 0 ? void 0 : session.SalesRepName) !== null && _c !== void 0 ? _c : fromStore === null || fromStore === void 0 ? void 0 : fromStore.customerName) !== null && _d !== void 0 ? _d : "").trim();
    return { customerId: customerId, customerName: customerName };
}
export function addHeaderToAPI() {
    var authenticationDetails = sessionStorage.getItem("Authorization");
    // Unicode-safe atob for different languages (Japanese, Chinese, etc.)
    parsedAuthentication = authenticationDetails ? JSON.parse(decodeURIComponent(escape(atob(authenticationDetails)))) : "";
    return {
        Authorization: "Bearer" + " " + parsedAuthentication.token,
        STApiVersion: "V2",
        XEncryptedPayload: "true",
    };
}
export var addOnclickEventOnShopifyAccountIcon = function (setIsDrawerOpen) {
    var _a;
    (_a = document.querySelectorAll('[href$="/account"]')) === null || _a === void 0 ? void 0 : _a.forEach(function (t) {
        t.addEventListener("click", function (e) {
            var hrefAttribute = t.getAttribute("href");
            if (hrefAttribute && (hrefAttribute === null || hrefAttribute === void 0 ? void 0 : hrefAttribute.split("?")[0].indexOf("/account")) > -1) {
                e.preventDefault();
                setIsDrawerOpen(true);
            }
        });
    });
};
var _a = getLoggedInRepDetails(), customerId = _a.customerId, customerName = _a.customerName, shopName = _a.shopName;
var CustomerId = parsedAuthentication.CustomerId, SalesRepName = parsedAuthentication.SalesRepName;
var baseUrlShopName = getLoggedInRepDetails().baseUrlShopName;
//export const baseUrl = "http://localhost:60499/customer/checkout";
//export const baseUrl = "https://salesrep-ppe16.azurewebsites.net/customer/checkout";
export var baseUrl = "https://" + baseUrlShopName + "/apps/SalesRep";
export function baseUrlWithCommonParams() {
    var _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, SalesRepName = _a.SalesRepName;
    //let baseUrlWithCommonParams = baseUrl + "?customerId=" + customerId + "&customerName=" + customerName + "&shop=" + shopName; // Local Common URL
    var baseUrlWithCommonParams = baseUrl + "?customerId=" + CustomerId + "&customerName=" + SalesRepName + "&shop=" + shopName; // Prod Common URL
    return baseUrlWithCommonParams;
}
export function salesRepBaseDataService() {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrlWithCommonParams() + "&data=1";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function salesRepOrdersDataService() {
    return __awaiter(this, void 0, void 0, function () {
        var _a, dateFrom, dateTo, pageSize, maxPages, merged, pageNumber, batch, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 5, , 6]);
                    _a = getDefaultWideDateRangeForSTOrderDetails(), dateFrom = _a.dateFrom, dateTo = _a.dateTo;
                    pageSize = ST_ORDER_DETAILS_DEFAULT_LIST_PAGE_SIZE;
                    maxPages = 100;
                    merged = [];
                    pageNumber = 1;
                    _b.label = 1;
                case 1:
                    if (!(pageNumber <= maxPages)) return [3 /*break*/, 4];
                    return [4 /*yield*/, fetchSTOrderDetailsOrdersPage(dateFrom, dateTo, pageNumber, pageSize)];
                case 2:
                    batch = _b.sent();
                    if (batch === null) {
                        if (pageNumber === 1) {
                            displaySnackbarErrMsg();
                            return [2 /*return*/, false];
                        }
                        logClientRuntimeError("salesRepOrdersDataService", new Error("Sales Order Details fetch stopped after page ".concat(pageNumber - 1)));
                        return [3 /*break*/, 4];
                    }
                    merged.push.apply(merged, batch);
                    if (batch.length < pageSize) {
                        return [3 /*break*/, 4];
                    }
                    _b.label = 3;
                case 3:
                    pageNumber++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/, splitSTOrderDetailsOrdersIntoLegacySlices(merged)];
                case 5:
                    error_3 = _b.sent();
                    logClientRuntimeError("salesRepOrdersDataService", error_3);
                    displaySnackbarErrMsg();
                    return [2 /*return*/, false];
                case 6: return [2 /*return*/];
            }
        });
    });
}
var stReportsFetchAbortController = null;
/** Cancels any in-flight GET `data=59` request (superseded tab/page/search fetch). */
export function cancelInFlightStReportsDataRequest() {
    if (stReportsFetchAbortController) {
        stReportsFetchAbortController.abort();
        stReportsFetchAbortController = null;
    }
}
/** Returns a fresh `AbortSignal` and aborts the previous ST Reports list request. */
export function beginStReportsDataRequest() {
    cancelInFlightStReportsDataRequest();
    stReportsFetchAbortController = new AbortController();
    return stReportsFetchAbortController.signal;
}
export function isStReportsRequestAborted(error) {
    if (!error || typeof error !== "object") {
        return false;
    }
    var err = error;
    return err.code === "ERR_CANCELED" || err.name === "AbortError" || err.name === "CanceledError";
}
export function stReportsDataService(request, options) {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse, error_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    url = baseUrlWithCommonParams() + appendStReportsSalesOrderDetailsQuerySegment(request);
                    return [4 /*yield*/, apiCallService(url, "", "GET", undefined, options === null || options === void 0 ? void 0 : options.signal).then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (!serviceCallResponse) {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    if (!(typeof serviceCallResponse === "string")) return [3 /*break*/, 3];
                    return [4 /*yield*/, decryptData(serviceCallResponse)];
                case 2:
                    serviceCallResponse = _a.sent();
                    _a.label = 3;
                case 3: return [2 /*return*/, normalizeStReportsOrdersApiPayload(serviceCallResponse) || false];
                case 4:
                    error_4 = _a.sent();
                    if (isStReportsRequestAborted(error_4)) {
                        return [2 /*return*/, false];
                    }
                    logClientRuntimeError("stReportsDataService", error_4);
                    displaySnackbarErrMsg();
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    });
}
export function stReportsCSVService(request) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, repCustomerId, repCustomerName, shopName, params, headers;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getLoggedInRepDetails(), repCustomerId = _a.customerId, repCustomerName = _a.customerName, shopName = _a.shopName;
                    params = __assign({ customerId: String(repCustomerId !== null && repCustomerId !== void 0 ? repCustomerId : ""), customerName: String(repCustomerName !== null && repCustomerName !== void 0 ? repCustomerName : ""), shop: shopName, data: "59" }, stReportsSalesOrderDetailsToFlatQueryParams(__assign(__assign({}, request), { exportCsv: true })));
                    headers = addHeaderToAPI();
                    return [4 /*yield*/, axios({
                            method: "get",
                            url: baseUrl,
                            responseType: "blob",
                            headers: headers,
                            params: params,
                        })
                            .then(function (response) { return response.data; })
                            .catch(function (error) {
                            logClientRuntimeError("stReportsCSVService", error);
                            displaySnackbarErrMsg();
                            return false;
                        })];
                case 1: return [2 /*return*/, _b.sent()];
            }
        });
    });
}
export function getViewCouponDataService() {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrlWithCommonParams() + "&data=8";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function createCouponService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, CustomerId, SalesRepName, data, url, serviceCallResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, SalesRepName = _a.SalesRepName;
                    return [4 /*yield*/, encryptData(JSON.stringify({ salesrepId: CustomerId, couponCode: params.discountCode, Discount: params.discountValue }))];
                case 1:
                    data = _b.sent();
                    url = baseUrl + "?data=" + data + "&pageIndex=3";
                    return [4 /*yield*/, apiCallService(url, "", "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function removeCouponService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var data, url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, encryptData(JSON.stringify(params))];
                case 1:
                    data = _a.sent();
                    url = baseUrl + "?data=" + data + "&pageIndex=4";
                    return [4 /*yield*/, apiCallService(url, "", "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function addCustomerDataService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, CustomerId, SalesRepName, data, url, serviceCallResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, SalesRepName = _a.SalesRepName;
                    return [4 /*yield*/, encryptData(JSON.stringify(__assign(__assign({}, params), { SalesRepId: CustomerId, SalesRepName: SalesRepName })))];
                case 1:
                    data = _b.sent();
                    url = baseUrl + "?data=" + data + "&pageIndex=13";
                    return [4 /*yield*/, apiCallService(url, "", "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function singleCustomerDataService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrlWithCommonParams() + "&clientId=" + params + "&data=25";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function orderCountDetailsService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, CustomerId, SalesRepName, url, serviceCallResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, SalesRepName = _a.SalesRepName;
                    url = baseUrl + "?customerId=" + params + "&customerName=" + SalesRepName + "&data=12";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function orderWiseProductsDataService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrlWithCommonParams() + "&clientId=" + params.clientId + "&orderId=" + params.order_id + "&data=19";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
/** Invoice column: load order/invoice payload from Shopify (dedicated wrapper; same route as data=19 today — change here if backend adds a new data code). */
export function fetchShopifyInvoiceForOrderService(orderId) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, orderWiseProductsDataService({ order_id: orderId, clientId: 0 })];
        });
    });
}
/** GET case 24: draft order Shopify `invoice_url` exposed on customer info (`InvoiceURL` in JSON). */
export function fetchDraftInvoiceUrlService(draftOrderId) {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrlWithCommonParams() + "&orderId=" + draftOrderId + "&data=24";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    displaySnackbarErrMsg();
                    return [2 /*return*/, false];
            }
        });
    });
}
export function customerAddressDataService(customerId) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, CustomerId, SalesRepName, shopName, url, serviceCallResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, SalesRepName = _a.SalesRepName;
                    shopName = getLoggedInRepDetails().shopName;
                    url = baseUrl + "?customerId=" + customerId + "&customerName=" + SalesRepName + "&shop=" + shopName + "&data=31";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function productRenderDataService() {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrlWithCommonParams() + "&data=14";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function createDraftOrderService(draftOrderData, isEditOrder) {
    return __awaiter(this, void 0, void 0, function () {
        var url, data, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrl + "?pageIndex=".concat(isEditOrder ? 44 : 0);
                    return [4 /*yield*/, encryptData(JSON.stringify(draftOrderData))];
                case 1:
                    data = _a.sent();
                    return [4 /*yield*/, apiCallService(url, data, "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    return [2 /*return*/, serviceCallResponse];
            }
        });
    });
}
export function checkCanCreateRepService() {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    url = baseUrlWithCommonParams() + "&pageIndex=61";
                    return [4 /*yield*/, apiCallService(url, "", "POST").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    return [2 /*return*/, { canCreateRep: true, message: "" }];
                case 2:
                    _a = _b.sent();
                    return [2 /*return*/, { canCreateRep: true, message: "" }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function addNewSalesRep(params) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, CustomerId, SalesRepName, data, url, serviceCallResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, SalesRepName = _a.SalesRepName;
                    return [4 /*yield*/, encryptData(JSON.stringify({
                            salesrepId: CustomerId,
                            email: params.email,
                            name: params.firstName,
                            TeamManagerName: SalesRepName,
                            Lname: params.lastName,
                            IsTeamManager: true,
                            RequestSignUpV2: true,
                        }))];
                case 1:
                    data = _b.sent();
                    url = baseUrlWithCommonParams() + "&data=" + data + "&pageIndex=21";
                    return [4 /*yield*/, apiCallService(url, "", "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function repOrderDetails(data) {
    return __awaiter(this, void 0, void 0, function () {
        var pageNumber, pageSize, shopForUrl, _a, dateFrom, dateTo, url, serviceCallResponse, norm, error_5;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 4, , 5]);
                    pageNumber = typeof (data === null || data === void 0 ? void 0 : data.pageNumber) === "number" && Number.isFinite(data.pageNumber) && data.pageNumber >= 1 ? Math.floor(data.pageNumber) : 1;
                    pageSize = typeof (data === null || data === void 0 ? void 0 : data.pageSize) === "number" && Number.isFinite(data.pageSize) && data.pageSize >= 1 ? Math.floor(data.pageSize) : ST_ORDER_DETAILS_DEFAULT_LIST_PAGE_SIZE;
                    shopForUrl = getLoggedInRepDetails().shopName;
                    _a = getDefaultWideDateRangeForSTOrderDetails(), dateFrom = _a.dateFrom, dateTo = _a.dateTo;
                    url = baseUrl +
                        "?customerId=" +
                        encodeURIComponent(data.repId) +
                        "&customerName=" +
                        encodeURIComponent(data.repName) +
                        "&shop=" +
                        encodeURIComponent(shopForUrl) +
                        appendStReportsSalesOrderDetailsQuerySegment({
                            dateFrom: dateFrom,
                            dateTo: dateTo,
                            dateField: "",
                            pageNumber: pageNumber,
                            pageSize: pageSize,
                            activeTab: "All",
                        });
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (d) { return d; })];
                case 1:
                    serviceCallResponse = _b.sent();
                    if (!(serviceCallResponse && typeof serviceCallResponse === "string")) return [3 /*break*/, 3];
                    return [4 /*yield*/, decryptData(serviceCallResponse)];
                case 2:
                    serviceCallResponse = _b.sent();
                    _b.label = 3;
                case 3:
                    if (!serviceCallResponse || serviceCallResponse === false) {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    norm = normalizeStReportsOrdersApiPayload(serviceCallResponse);
                    if (!norm || !Array.isArray(norm.Orders)) {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/, splitSTOrderDetailsOrdersIntoLegacySlices(norm.Orders)];
                case 4:
                    error_5 = _b.sent();
                    logClientRuntimeError("repOrderDetails", error_5);
                    displaySnackbarErrMsg();
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    });
}
export function deleteShareCartLinkService(deleteShareCartLinkData) {
    return __awaiter(this, void 0, void 0, function () {
        var data, url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, encryptData(JSON.stringify(deleteShareCartLinkData))];
                case 1:
                    data = _a.sent();
                    url = baseUrl + "?data=" + data + "&pageIndex=31";
                    return [4 /*yield*/, apiCallService(url, "", "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function createCartService(createCartData) {
    return __awaiter(this, void 0, void 0, function () {
        var data, url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, encryptData(createCartData)];
                case 1:
                    data = _a.sent();
                    url = baseUrl + "?pageIndex=30";
                    return [4 /*yield*/, apiCallService(url, data, "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function getSharedCartDetailsByIdService(cartUniqueId, forceRefresh) {
    if (forceRefresh === void 0) { forceRefresh = false; }
    return __awaiter(this, void 0, void 0, function () {
        var _a, CustomerId, SalesRepName, shopName, url, serviceCallResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, SalesRepName = _a.SalesRepName;
                    shopName = getLoggedInRepDetails().shopName;
                    url = baseUrl +
                        "?shop=" +
                        shopName +
                        "&customerId=" +
                        CustomerId +
                        "&customerName=" +
                        SalesRepName +
                        "&repId=" +
                        CustomerId +
                        "&data=28&cartuniqueid=" +
                        encodeURIComponent(cartUniqueId);
                    if (forceRefresh) {
                        // 	url += "&_t=" + Date.now();
                    }
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function draftOrderDataService() {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrlWithCommonParams() + "&data=2";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function draftOrderDetailsService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrlWithCommonParams() + "&orderId=" + params.order_id + "&data=20";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function duplicateOrderService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var url, isDraftOrder, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrlWithCommonParams() + "&orderId=" + params.order_id + "&data=55";
                    isDraftOrder = params.isDraftOrder !== undefined ? params.isDraftOrder : false;
                    url += "&isDraftOrder=" + isDraftOrder;
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function sendInvoiceDataService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var shopName, data, url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    shopName = getLoggedInRepDetails().shopName;
                    return [4 /*yield*/, encryptData(JSON.stringify({ orderid: params.orderid, shopname: shopName, emailid: params.emailid }))];
                case 1:
                    data = _a.sent();
                    url = baseUrl + "?data=" + data + "&pageIndex=02";
                    return [4 /*yield*/, apiCallService(url, "", "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function deleteInvoiceService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var SalesRepName, data, url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    SalesRepName = getLoggedInRepDetailsFromSession().SalesRepName;
                    return [4 /*yield*/, encryptData(JSON.stringify({ orderid: params }))];
                case 1:
                    data = _a.sent();
                    url = baseUrl + "?&customerName=" + SalesRepName + "&data=" + data + "&pageIndex=14";
                    return [4 /*yield*/, apiCallService(url, "", "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse !== null && (serviceCallResponse === null || serviceCallResponse === void 0 ? void 0 : serviceCallResponse.data)) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function refundOrderDataService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, customerId, customerName, shopName, url, serviceCallResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getRepCustomerIdAndNameForApi(), customerId = _a.customerId, customerName = _a.customerName;
                    shopName = getLoggedInRepDetails().shopName;
                    url = baseUrl + "?shop=" + shopName + "&customerId=" + customerId + "&customerName=" + customerName + "&orderId=" + params.orderId + "&refundId=" + params.refundId + "&data=35";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function uploadAffiliateLinkData(params) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, CustomerId, SalesRepName, data, url, serviceCallResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, SalesRepName = _a.SalesRepName;
                    return [4 /*yield*/, encryptData(JSON.stringify(__assign({ repId: CustomerId, repname: SalesRepName }, params)))];
                case 1:
                    data = _b.sent();
                    url = baseUrl + "?data=" + data + "&pageIndex=8";
                    return [4 /*yield*/, apiCallService(url, "", "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function uploadAffiliatePhoto(params) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, CustomerId, SalesRepName, imageFile, data, url, serviceCallResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, SalesRepName = _a.SalesRepName;
                    imageFile = new FormData();
                    imageFile.append("postedFile", params);
                    return [4 /*yield*/, encryptData(JSON.stringify({ repId: CustomerId }))];
                case 1:
                    data = _b.sent();
                    url = baseUrl + "?data=" + data + "&pageIndex=28";
                    return [4 /*yield*/, apiCallService(url, imageFile, "POST", "multipart/form-data").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function GetAllWholesalePriceService() {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrlWithCommonParams() + "&data=30";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function submitSignupRepDetailsService(signupRepDetails) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var _c, CustomerId, SalesRepName, fileUpload, cvUpload, fileData, signupShopName, additionalInfo, userDetails, encryptedUserDetails, url, serviceCallResponse;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _c = getLoggedInRepDetailsFromSession(), CustomerId = _c.CustomerId, SalesRepName = _c.SalesRepName;
                    fileUpload = signupRepDetails.fileUpload;
                    cvUpload = signupRepDetails.cvUpload;
                    fileData = new FormData();
                    // Add profile photo if exists
                    if (fileUpload) {
                        fileData.append("postedFile", fileUpload);
                    }
                    // Add CV file if exists
                    if (cvUpload) {
                        fileData.append("cvFile", cvUpload);
                    }
                    signupShopName = getLoggedInRepDetails().shopName;
                    additionalInfo = {};
                    if (signupShopName === "z0ritp-ea.myshopify.com") {
                        if ((_a = signupRepDetails.userDetails.city) === null || _a === void 0 ? void 0 : _a.trim())
                            additionalInfo["City"] = signupRepDetails.userDetails.city.trim();
                        if ((_b = signupRepDetails.userDetails.state) === null || _b === void 0 ? void 0 : _b.trim())
                            additionalInfo["State"] = signupRepDetails.userDetails.state.trim();
                    }
                    userDetails = {
                        email: signupRepDetails.userDetails.emailId,
                        name: signupRepDetails.userDetails.firstName,
                        TeamManagerName: SalesRepName,
                        Lname: signupRepDetails.userDetails.lastName,
                        IsTeamManager: false,
                        PhNumber: signupRepDetails.userDetails.phoneNumber,
                        fbHandle: signupRepDetails.userDetails.fbHandle,
                        InstaHandle: signupRepDetails.userDetails.instHandle,
                        linkedin: signupRepDetails.userDetails.linkedin,
                        coverMessage: signupRepDetails.userDetails.coverMessage,
                        signUpRequestV2: 1,
                    };
                    if (Object.keys(additionalInfo).length > 0) {
                        userDetails.AdditionalInformation = JSON.stringify(additionalInfo);
                    }
                    return [4 /*yield*/, encryptData(JSON.stringify(userDetails))];
                case 1:
                    encryptedUserDetails = _d.sent();
                    url = baseUrl + "?data=" + encryptedUserDetails + "&pageIndex=21";
                    return [4 /*yield*/, apiCallService(url, fileData, "POST", "multipart/form-data").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _d.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function userLoginService(userDetails) {
    return __awaiter(this, void 0, void 0, function () {
        var data, url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, encryptData(JSON.stringify({ email: userDetails.emailField, password: userDetails.passwordField }))];
                case 1:
                    data = _a.sent();
                    url = baseUrl + "?pageIndex=45";
                    return [4 /*yield*/, apiCallService(url, data, "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function forgotPasswordService(email) {
    return __awaiter(this, void 0, void 0, function () {
        var data, url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, encryptData(JSON.stringify({ email: email }))];
                case 1:
                    data = _a.sent();
                    url = baseUrl + "?pageIndex=46";
                    return [4 /*yield*/, apiCallService(url, data, "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function DataAddOnCart(parameter, type) {
    return __awaiter(this, void 0, void 0, function () {
        var shopName, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    shopName = getLoggedInRepDetails().shopName;
                    if (type === "add.js") {
                        //parameter:Array<object> Format
                        data = {
                            items: parameter,
                        };
                    }
                    else if (type === "update.js") {
                        //parameter:object Format
                        data = {
                            updates: parameter,
                        };
                    }
                    else {
                        data = parameter;
                    }
                    return [4 /*yield*/, axios({
                            method: "post",
                            url: "/cart/" + type,
                            data: JSON.stringify(data),
                            headers: {
                                "Content-type": "application/json",
                            },
                        })
                            .then(function (response) {
                            return true;
                        })
                            .catch(function (error) {
                            //displaySnackbarErrMsg();
                            return error;
                        })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function getShippingRatesService(seletCustomerAddress) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    return __awaiter(this, void 0, void 0, function () {
        var ErrorMessage, shopName, prepareShippingResponse, asyncShippingResponse, error_6, error_7, UnprocessableEntityObject, countryError;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    ErrorMessage = "";
                    shopName = getLoggedInRepDetails().shopName;
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 8, , 9]);
                    return [4 /*yield*/, axios({
                            method: "post",
                            url: "/cart/prepare_shipping_rates.json",
                            params: {
                                "shipping_address[zip]": seletCustomerAddress.customerZip,
                                "shipping_address[country]": seletCustomerAddress.customerCountry,
                                "shipping_address[province]": seletCustomerAddress.customerProvince,
                            },
                        })];
                case 2:
                    prepareShippingResponse = _k.sent();
                    if (!(prepareShippingResponse.status === 202)) return [3 /*break*/, 7];
                    // Wait for some time to allow the server to process
                    return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 5000); })];
                case 3:
                    // Wait for some time to allow the server to process
                    _k.sent();
                    _k.label = 4;
                case 4:
                    _k.trys.push([4, 6, , 7]);
                    return [4 /*yield*/, axios({
                            method: "get",
                            url: "/cart/async_shipping_rates.json",
                            params: {
                                "shipping_address[zip]": seletCustomerAddress.customerZip,
                                "shipping_address[country]": seletCustomerAddress.customerCountry,
                                "shipping_address[province]": seletCustomerAddress.customerProvince,
                            },
                        })];
                case 5:
                    asyncShippingResponse = _k.sent();
                    ErrorMessage = "Success";
                    return [2 /*return*/, __assign(__assign({}, asyncShippingResponse.data), { message: ErrorMessage })];
                case 6:
                    error_6 = _k.sent();
                    ErrorMessage = error_6.message;
                    displaySnackbarErrMsg();
                    return [2 /*return*/, { message: ErrorMessage }];
                case 7: return [3 /*break*/, 9];
                case 8:
                    error_7 = _k.sent();
                    if (((_a = error_7 === null || error_7 === void 0 ? void 0 : error_7.request) === null || _a === void 0 ? void 0 : _a.status) === 0) {
                        ErrorMessage = "Network Problem";
                    }
                    else if (((_b = error_7 === null || error_7 === void 0 ? void 0 : error_7.request) === null || _b === void 0 ? void 0 : _b.status) === 404) {
                        ErrorMessage = "Not Found";
                    }
                    else if (((_c = error_7 === null || error_7 === void 0 ? void 0 : error_7.request) === null || _c === void 0 ? void 0 : _c.status) === 422) {
                        UnprocessableEntityObject = JSON.parse((_e = (_d = error_7 === null || error_7 === void 0 ? void 0 : error_7.request) === null || _d === void 0 ? void 0 : _d.responseText) !== null && _e !== void 0 ? _e : "{}");
                        if (UnprocessableEntityObject && (UnprocessableEntityObject === null || UnprocessableEntityObject === void 0 ? void 0 : UnprocessableEntityObject.zip) && ((_f = UnprocessableEntityObject === null || UnprocessableEntityObject === void 0 ? void 0 : UnprocessableEntityObject.zip) === null || _f === void 0 ? void 0 : _f[0])) {
                            ErrorMessage = ErrorMessage ? "".concat(ErrorMessage, ", ").concat(UnprocessableEntityObject.zip[0]) : UnprocessableEntityObject.zip[0];
                        }
                        if (UnprocessableEntityObject && (UnprocessableEntityObject === null || UnprocessableEntityObject === void 0 ? void 0 : UnprocessableEntityObject.country) && ((_g = UnprocessableEntityObject === null || UnprocessableEntityObject === void 0 ? void 0 : UnprocessableEntityObject.country) === null || _g === void 0 ? void 0 : _g[0])) {
                            countryError = UnprocessableEntityObject.country[0];
                            if (countryError === "Country/region not supported") {
                                countryError = "Shipping cost for selected address is not configured. Please contact admin.";
                            }
                            ErrorMessage = ErrorMessage ? "".concat(ErrorMessage, ", ").concat(countryError) : countryError;
                        }
                        if (UnprocessableEntityObject && (UnprocessableEntityObject === null || UnprocessableEntityObject === void 0 ? void 0 : UnprocessableEntityObject.province) && ((_h = UnprocessableEntityObject === null || UnprocessableEntityObject === void 0 ? void 0 : UnprocessableEntityObject.province) === null || _h === void 0 ? void 0 : _h[0])) {
                            ErrorMessage = ErrorMessage ? "".concat(ErrorMessage, ", ").concat(UnprocessableEntityObject.province[0]) : UnprocessableEntityObject.province[0];
                        }
                        if ((_j = UnprocessableEntityObject === null || UnprocessableEntityObject === void 0 ? void 0 : UnprocessableEntityObject.error) === null || _j === void 0 ? void 0 : _j[0]) {
                            ErrorMessage = ErrorMessage ? "".concat(ErrorMessage, ", ").concat(UnprocessableEntityObject.error[0]) : UnprocessableEntityObject.error[0];
                        }
                    }
                    else {
                        ErrorMessage = error_7 === null || error_7 === void 0 ? void 0 : error_7.message;
                    }
                    return [2 /*return*/, { message: ErrorMessage }];
                case 9: return [2 /*return*/];
            }
        });
    });
}
export function updatePasswordService(passwordObject) {
    return __awaiter(this, void 0, void 0, function () {
        var CustomerId, email, data, url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    CustomerId = parsedAuthentication.CustomerId, email = parsedAuthentication.email;
                    return [4 /*yield*/, encryptData(JSON.stringify(__assign({ customerId: CustomerId, email: email }, passwordObject)))];
                case 1:
                    data = _a.sent();
                    url = baseUrl + "?pageIndex=47";
                    return [4 /*yield*/, apiCallService(url, data, "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function GetCartData() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, axios({
                        method: "get",
                        url: "/cart.js",
                        headers: {
                            "Content-type": "application/json",
                        },
                    })
                        .then(function (response) {
                        return response;
                    })
                        .catch(function (error) {
                        //displaySnackbarErrMsg();
                        return error;
                    })];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
}
export function getProductDetailsByVariantIdsService(variantIds, storefrontAccessToken) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function () {
        var shopName_1, apiUrl, variantGids, graphqlQuery, headers, response, error_8;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    shopName_1 = getLoggedInRepDetails().shopName;
                    apiUrl = "https://".concat(shopName_1, "/api/2026-01/graphql.json");
                    variantGids = variantIds.map(function (id) { return "gid://shopify/ProductVariant/".concat(id); });
                    graphqlQuery = "{\n\t\t\tnodes(ids: ".concat(JSON.stringify(variantGids), ") {\n\t\t\t\t... on ProductVariant {\n\t\t\t\t\tid\n\t\t\t\t\ttitle\n\t\t\t\t\tprice {\n\t\t\t\t\t\tamount\n\t\t\t\t\t\tcurrencyCode\n\t\t\t\t\t}\n\t\t\t\t\timage {\n\t\t\t\t\t\turl\n\t\t\t\t\t\taltText\n\t\t\t\t\t}\n\t\t\t\t\tquantityAvailable\n\t\t\t\t\tavailableForSale\n\t\t\t\t\tsku\n\t\t\t\t\tproduct {\n\t\t\t\t\t\tid\n\t\t\t\t\t\ttitle\n\t\t\t\t\t\thandle\n\t\t\t\t\t\timages(first: 1) {\n\t\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\t\turl\n\t\t\t\t\t\t\t\t\taltText\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}");
                    headers = {
                        "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
                        "Content-Type": "application/json",
                    };
                    return [4 /*yield*/, axios({
                            method: "POST",
                            url: apiUrl,
                            headers: headers,
                            data: { query: graphqlQuery },
                        })];
                case 1:
                    response = _f.sent();
                    if ((response === null || response === void 0 ? void 0 : response.status) === 200 && ((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.nodes)) {
                        // Filter out null nodes (in case some IDs don't exist)
                        return [2 /*return*/, response.data.data.nodes.filter(function (node) { return node !== null; })];
                    }
                    else {
                        console.error("GraphQL response error:", ((_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.errors) || "Unknown error");
                        return [2 /*return*/, []];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_8 = _f.sent();
                    console.error("Error in getProductDetailsByVariantIdsService:", error_8);
                    if ((_e = (_d = error_8 === null || error_8 === void 0 ? void 0 : error_8.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.errors) {
                        console.error("GraphQL errors:", error_8.response.data.errors);
                    }
                    return [2 /*return*/, []];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function affiliateLinkConfirmationService(affiliatePopUpVisible) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, CustomerId, SalesRepName, shopName, data, url, serviceCallResponse;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _a = getLoggedInRepDetailsFromSession(), CustomerId = _a.CustomerId, SalesRepName = _a.SalesRepName;
                    shopName = getLoggedInRepDetails().shopName;
                    return [4 /*yield*/, encryptData(JSON.stringify({
                            shopName: shopName,
                            customerId: CustomerId,
                            affiliatePopUpVisible: affiliatePopUpVisible,
                        }))];
                case 1:
                    data = _b.sent();
                    url = baseUrl + "?pageIndex=52";
                    return [4 /*yield*/, apiCallService(url, data, "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function GetProductDataService(searchValue, storefrontAccessToken, startCursor, endCursor, collectionId, productIds, collectionIds) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function () {
        var shopName_2, apiUrl, productsPerPage, variantsPerPage, beforeOrAfterCursor, firstOrLast, allProducts, headers, productIdsQuery, resolvedCollectionIds, graphqlQuery, collectionGids, collectionIdsString, response, responseData, validCollections, allCollectionProducts_1, collectionPageInfoMap_1, parsedData_1, pageInfo, products, parsedData, normalizedSearch_1, matchesTitle_1, matchesSku_1, fallbackMatches, sortedProducts, error_9;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 5, , 6]);
                    shopName_2 = getLoggedInRepDetails().shopName;
                    apiUrl = "https://".concat(shopName_2, "/api/2026-01/graphql.json");
                    productsPerPage = 25;
                    variantsPerPage = 120;
                    beforeOrAfterCursor = "";
                    firstOrLast = "first:".concat(productsPerPage);
                    allProducts = [];
                    if (startCursor) {
                        beforeOrAfterCursor = "after:" + '"' + startCursor + '"';
                        firstOrLast = "first:".concat(productsPerPage);
                    }
                    else if (endCursor) {
                        beforeOrAfterCursor = "before:" + '"' + endCursor + '"';
                        firstOrLast = "last:".concat(productsPerPage);
                    }
                    headers = {
                        "X-Shopify-Storefront-Access-Token": storefrontAccessToken,
                        "Content-Type": "application/json",
                    };
                    productIdsQuery = void 0;
                    if (productIds) {
                        productIdsQuery = productIds === null || productIds === void 0 ? void 0 : productIds.map(function (id) {
                            var numericProductId = id === null || id === void 0 ? void 0 : id.split("/").pop();
                            return "id:".concat(numericProductId);
                        }).join(" OR ");
                    }
                    else if (searchValue && searchValue !== "") {
                        productIdsQuery = searchValue;
                    }
                    else {
                        productIdsQuery = "";
                    }
                    resolvedCollectionIds = (collectionIds === null || collectionIds === void 0 ? void 0 : collectionIds.length) ? collectionIds : collectionId != null ? [collectionId] : [];
                    graphqlQuery = void 0;
                    if (resolvedCollectionIds.length === 0) {
                        // Show specific collection OFF: use products query (search / product IDs)
                        graphqlQuery = "{\n            products(".concat(firstOrLast, ", query: \"(").concat(productIdsQuery, ")\" ").concat(beforeOrAfterCursor, ") {\n                edges {\n                    node {\n                        id\n                        title\n                        handle\n                        productType\n                        images(first: 1) {\n                            edges {\n                                node {\n                                    url\n                                }\n                            }\n                        }\n                        variants(first: ").concat(variantsPerPage, ") {\n                            edges {\n                                node {\n                                    id\n                                    price {\n                                        amount\n                                        currencyCode\n                                    }\n                                    image {\n                                        url\n                                    }\n                                    sku\n                                    title\n                                    quantityAvailable\n                                    availableForSale\n                                }\n                            }\n                        }\n                    }\n                }\n                pageInfo {\n                    hasPreviousPage\n                    hasNextPage\n                    startCursor\n                    endCursor\n                }\n            }\n        }");
                    }
                    else {
                        collectionGids = resolvedCollectionIds.map(function (id) { return "gid://shopify/Collection/".concat(id); });
                        collectionIdsString = collectionGids.map(function (id) { return "\"".concat(id, "\""); }).join(", ");
                        graphqlQuery = "{\n\t\t\t\tnodes(ids: [".concat(collectionIdsString, "]) {\n\t\t\t\t\t... on Collection {\n\t\t\t\t\t\tid\n\t\t\t\t\t\tproducts(").concat(firstOrLast).concat(beforeOrAfterCursor ? ", ".concat(beforeOrAfterCursor) : "", ") {\n\t\t\t\t\t\t\tnodes {\n\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t\thandle\n\t\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\t\tproductType\n\t\t\t\t\t\t\t\timages(first: 10) {\n\t\t\t\t\t\t\t\t\tedges {\n\t\t\t\t\t\t\t\t\t\tnode {\n\t\t\t\t\t\t\t\t\t\t\turl\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\tvariants(first: ").concat(variantsPerPage, ") {\n\t\t\t\t\t\t\t\t\tnodes {\n\t\t\t\t\t\t\t\t\t\tid\n\t\t\t\t\t\t\t\t\t\tprice {\n\t\t\t\t\t\t\t\t\t\t\tamount\n\t\t\t\t\t\t\t\t\t\t\tcurrencyCode\n\t\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t\t\tsku\n\t\t\t\t\t\t\t\t\t\ttitle\n\t\t\t\t\t\t\t\t\t\tquantityAvailable\n\t\t\t\t\t\t\t\t\t\tavailableForSale\n\t\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tpageInfo {\n\t\t\t\t\t\t\t\thasPreviousPage\n\t\t\t\t\t\t\t\thasNextPage\n\t\t\t\t\t\t\t\tstartCursor\n\t\t\t\t\t\t\t\tendCursor\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}");
                    }
                    return [4 /*yield*/, axios({
                            method: "POST",
                            url: apiUrl,
                            headers: headers,
                            data: { query: graphqlQuery },
                        })];
                case 1:
                    response = _g.sent();
                    responseData = response === null || response === void 0 ? void 0 : response.data;
                    // Check for errors in the response
                    if ((response === null || response === void 0 ? void 0 : response.status) !== 200) {
                        throw new Error("Error fetching product data due to a network or server issue.");
                    }
                    if (!(resolvedCollectionIds.length > 0)) return [3 /*break*/, 3];
                    if (!((_a = responseData.data) === null || _a === void 0 ? void 0 : _a.nodes)) {
                        throw new Error("Error fetching product data: No collections found.");
                    }
                    validCollections = responseData.data.nodes.filter(function (node) { return node !== null; });
                    allCollectionProducts_1 = [];
                    collectionPageInfoMap_1 = [];
                    validCollections.forEach(function (collectionNode) {
                        var _a;
                        if (collectionNode === null || collectionNode === void 0 ? void 0 : collectionNode.products) {
                            if (collectionNode.products.nodes) {
                                allCollectionProducts_1.push.apply(allCollectionProducts_1, collectionNode.products.nodes);
                            }
                            if (collectionNode.products.pageInfo) {
                                var numericId = (_a = collectionNode.id) === null || _a === void 0 ? void 0 : _a.replace("gid://shopify/Collection/", "");
                                if (numericId) {
                                    collectionPageInfoMap_1.push({
                                        collectionId: Number(numericId),
                                        pageInfo: collectionNode.products.pageInfo,
                                    });
                                }
                            }
                        }
                    });
                    return [4 /*yield*/, parseGraphQLCollectionResponse(allCollectionProducts_1)];
                case 2:
                    parsedData_1 = _g.sent();
                    pageInfo = resolvedCollectionIds.length === 1 ? (_c = (_b = collectionPageInfoMap_1[0]) === null || _b === void 0 ? void 0 : _b.pageInfo) !== null && _c !== void 0 ? _c : null : null;
                    return [2 /*return*/, { products: parsedData_1, pageInfo: pageInfo, collectionPageInfoMap: collectionPageInfoMap_1 }];
                case 3:
                    if (!((_d = responseData.data) === null || _d === void 0 ? void 0 : _d.products)) {
                        throw new Error("Error fetching product data: No products found.");
                    }
                    products = responseData === null || responseData === void 0 ? void 0 : responseData.data;
                    allProducts = allProducts === null || allProducts === void 0 ? void 0 : allProducts.concat(products);
                    return [4 /*yield*/, parseGraphQLResponse(allProducts)];
                case 4:
                    parsedData = _g.sent();
                    normalizedSearch_1 = searchValue === null || searchValue === void 0 ? void 0 : searchValue.trim().toLowerCase();
                    matchesTitle_1 = parsedData.filter(function (p) { var _a; return (_a = p === null || p === void 0 ? void 0 : p.title) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(normalizedSearch_1); });
                    matchesSku_1 = parsedData.filter(function (p) { var _a; return !matchesTitle_1.includes(p) && ((_a = p === null || p === void 0 ? void 0 : p.variants) === null || _a === void 0 ? void 0 : _a.some(function (v) { var _a; return (_a = v === null || v === void 0 ? void 0 : v.sku) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(normalizedSearch_1); })); });
                    fallbackMatches = parsedData.filter(function (p) { return !matchesTitle_1.includes(p) && !matchesSku_1.includes(p); });
                    sortedProducts = __spreadArray(__spreadArray(__spreadArray([], matchesTitle_1, true), fallbackMatches, true), matchesSku_1, true);
                    return [2 /*return*/, { products: sortedProducts, pageInfo: (_f = (_e = responseData === null || responseData === void 0 ? void 0 : responseData.data) === null || _e === void 0 ? void 0 : _e.products) === null || _f === void 0 ? void 0 : _f.pageInfo }];
                case 5:
                    error_9 = _g.sent();
                    console.log(error_9);
                    throw error_9; // Rethrow the error for the calling code to handle
                case 6: return [2 /*return*/];
            }
        });
    });
}
// function to parse the GraphQL response
function parseGraphQLResponse(response) {
    try {
        if (response) {
            var parsedData = response === null || response === void 0 ? void 0 : response.map(function (productSet) {
                var productEdges = productSet.products.edges;
                var products = productEdges === null || productEdges === void 0 ? void 0 : productEdges.map(function (productEdge) {
                    var _a, _b, _c, _d;
                    var product = productEdge.node;
                    var variants = (_a = product === null || product === void 0 ? void 0 : product.variants.edges) === null || _a === void 0 ? void 0 : _a.map(function (variantEdge) {
                        var _a, _b, _c, _d;
                        var variant = variantEdge === null || variantEdge === void 0 ? void 0 : variantEdge.node;
                        return {
                            variantId: variant === null || variant === void 0 ? void 0 : variant.id,
                            variantPrice: Number((_a = variant === null || variant === void 0 ? void 0 : variant.price) === null || _a === void 0 ? void 0 : _a.amount),
                            imageUrl: ((_b = variant === null || variant === void 0 ? void 0 : variant.image) === null || _b === void 0 ? void 0 : _b.url) || null,
                            currency: (_c = variant === null || variant === void 0 ? void 0 : variant.price) === null || _c === void 0 ? void 0 : _c.currencyCode,
                            inventoryQuantity: variant === null || variant === void 0 ? void 0 : variant.inventoryQuantity,
                            sku: variant === null || variant === void 0 ? void 0 : variant.sku,
                            title: variant === null || variant === void 0 ? void 0 : variant.title,
                            quantityAvailable: variant === null || variant === void 0 ? void 0 : variant.quantityAvailable,
                            availableForSale: variant === null || variant === void 0 ? void 0 : variant.availableForSale,
                            product_type: (_d = product === null || product === void 0 ? void 0 : product.productType) !== null && _d !== void 0 ? _d : "",
                        };
                    });
                    return {
                        productId: product === null || product === void 0 ? void 0 : product.id,
                        handle: product === null || product === void 0 ? void 0 : product.handle,
                        title: product === null || product === void 0 ? void 0 : product.title,
                        variants: variants,
                        imageUrl: ((_d = (_c = (_b = product === null || product === void 0 ? void 0 : product.images) === null || _b === void 0 ? void 0 : _b.edges[0]) === null || _c === void 0 ? void 0 : _c.node) === null || _d === void 0 ? void 0 : _d.url) || null, // Check if image is available
                    };
                });
                return products;
            });
            // Flatten the array of products from multiple sets
            var flattenedData = parsedData.flat();
            return flattenedData;
        }
    }
    catch (error) {
        console.error("Error parsing GraphQL response:", error);
        return [];
    }
}
function parseGraphQLCollectionResponse(productSet) {
    try {
        // Directly map over the nodes assuming it's the product structure shown in your response
        var products = productSet === null || productSet === void 0 ? void 0 : productSet.map(function (product) {
            var _a, _b, _c, _d;
            var variants = (_a = product === null || product === void 0 ? void 0 : product.variants.nodes) === null || _a === void 0 ? void 0 : _a.map(function (variant) {
                var _a, _b, _c;
                return {
                    variantId: variant === null || variant === void 0 ? void 0 : variant.id,
                    variantPrice: Number((_a = variant === null || variant === void 0 ? void 0 : variant.price) === null || _a === void 0 ? void 0 : _a.amount),
                    currency: (_b = variant === null || variant === void 0 ? void 0 : variant.price) === null || _b === void 0 ? void 0 : _b.currencyCode,
                    sku: variant === null || variant === void 0 ? void 0 : variant.sku,
                    title: variant === null || variant === void 0 ? void 0 : variant.title,
                    quantityAvailable: variant === null || variant === void 0 ? void 0 : variant.quantityAvailable,
                    availableForSale: variant === null || variant === void 0 ? void 0 : variant.availableForSale,
                    product_type: (_c = product === null || product === void 0 ? void 0 : product.productType) !== null && _c !== void 0 ? _c : "",
                };
            });
            return {
                productId: product.id,
                handle: product.handle,
                title: product === null || product === void 0 ? void 0 : product.title,
                variants: variants,
                imageUrl: ((_d = (_c = (_b = product === null || product === void 0 ? void 0 : product.images) === null || _b === void 0 ? void 0 : _b.edges[0]) === null || _c === void 0 ? void 0 : _c.node) === null || _d === void 0 ? void 0 : _d.url) || null,
                productType: product === null || product === void 0 ? void 0 : product.productType,
            };
        });
        return products;
    }
    catch (error) {
        console.error("Error parsing GraphQL collection response:", error);
        return [];
    }
}
export function GetCompanyLocationPricelistService(companyLocationId, objectToPass) {
    return __awaiter(this, void 0, void 0, function () {
        var isPaginationAdded, url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isPaginationAdded = "True";
                    url = baseUrlWithCommonParams() + "&companyLocationId=" + companyLocationId + "&b2bPricesCatalogDetails=" + objectToPass + "&isPaginationAdded=" + isPaginationAdded + "&data=41";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function GetCompanyLocationSearchedPricelistService(companyLocationId, b2bCatalogDetails) {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrlWithCommonParams() + "&companyLocationId=" + companyLocationId + "&b2bPricesCatalogDetails=" + b2bCatalogDetails + "&data=47";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function GetCompanyLocationQuantityRuleService(catalogAndVariantDict) {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrlWithCommonParams() + "&catalogVariantData=" + catalogAndVariantDict + "&data=48";
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 1:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [2 /*return*/];
            }
        });
    });
}
export function createB2bDraftOrderService(draftOrderData) {
    return __awaiter(this, void 0, void 0, function () {
        var url, data, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrl + "?pageIndex=51";
                    return [4 /*yield*/, encryptData(JSON.stringify(draftOrderData))];
                case 1:
                    data = _a.sent();
                    return [4 /*yield*/, apiCallService(url, data, "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    return [2 /*return*/, serviceCallResponse];
            }
        });
    });
}
export function updateB2bDraftOrderService(draftOrderData, orderId) {
    return __awaiter(this, void 0, void 0, function () {
        var url, data, serviceCallResponse;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = baseUrl + "?pageIndex=59&orderId=".concat(orderId);
                    return [4 /*yield*/, encryptData(JSON.stringify(draftOrderData))];
                case 1:
                    data = _a.sent();
                    return [4 /*yield*/, apiCallService(url, data, "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    return [2 /*return*/, serviceCallResponse];
            }
        });
    });
}
// Get API call
export function B2BCreateCompanyGetService(resourceNo, resourceId) {
    return __awaiter(this, void 0, void 0, function () {
        var url, serviceCallResponse, error_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = "";
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    if (resourceNo == "3") {
                        url = baseUrlWithCommonParams() + "&resourceId=" + resourceId + "&resourceNo=" + resourceNo + "&data=49";
                    }
                    else {
                        url = baseUrlWithCommonParams() + "&resourceNo=" + resourceNo + "&data=49";
                    }
                    return [4 /*yield*/, apiCallService(url, "", "GET").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_10 = _a.sent();
                    return [2 /*return*/, { success: false, errorMessage: "Internal server error" }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
// Post API call
export function B2BCreateUpdateCompanyPostService(B2BCompanyDetails, resourceNo) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var url, data, serviceCallResponse, errorMsg, createdCompany, error_11;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    url = baseUrl + "?data=" + resourceNo + "&pageIndex=54";
                    return [4 /*yield*/, encryptData(JSON.stringify(B2BCompanyDetails))];
                case 1:
                    data = _b.sent();
                    return [4 /*yield*/, apiCallService(url, data, "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse) {
                        errorMsg = (_a = serviceCallResponse === null || serviceCallResponse === void 0 ? void 0 : serviceCallResponse.b2bCompanyDetails) === null || _a === void 0 ? void 0 : _a.ErrorMessage;
                        // Handle Create Company
                        if (resourceNo === "4") {
                            createdCompany = serviceCallResponse === null || serviceCallResponse === void 0 ? void 0 : serviceCallResponse.b2bCompanyDetails;
                            if (createdCompany && (createdCompany === null || createdCompany === void 0 ? void 0 : createdCompany.Id) && !errorMsg) {
                                return [2 /*return*/, { success: true, company: createdCompany }];
                            }
                            else {
                                return [2 /*return*/, { success: false, errorMessage: errorMsg || "Failed to create company." }];
                            }
                        }
                        // Generic case
                        if ((serviceCallResponse === null || serviceCallResponse === void 0 ? void 0 : serviceCallResponse.b2bCompanyDetails) && !errorMsg) {
                            return [2 /*return*/, { success: true, errorMessage: "" }];
                        }
                        else if (errorMsg) {
                            return [2 /*return*/, { success: false, errorMessage: errorMsg }];
                        }
                        else {
                            return [2 /*return*/, { success: false, errorMessage: "Unknown server error" }];
                        }
                    }
                    else {
                        return [2 /*return*/, { success: false, errorMessage: "No response from server" }];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_11 = _b.sent();
                    return [2 /*return*/, { success: false, errorMessage: "Internal server error" }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function updateExistingCustomerDataService(params) {
    return __awaiter(this, void 0, void 0, function () {
        var CustomerId_1, SalesRepName_1, data, url, serviceCallResponse, error_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    CustomerId_1 = parsedAuthentication.CustomerId, SalesRepName_1 = parsedAuthentication.SalesRepName;
                    return [4 /*yield*/, encryptData(JSON.stringify(__assign({ customerId: CustomerId_1, SalesRepName: SalesRepName_1 }, params)))];
                case 1:
                    data = _a.sent();
                    url = baseUrl + "?pageIndex=55";
                    return [4 /*yield*/, apiCallService(url, data, "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse !== null) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_12 = _a.sent();
                    return [2 /*return*/, { success: false, errorMessage: "Internal server error" }];
                case 4: return [2 /*return*/];
            }
        });
    });
}
//Remove Contact Card and Profile Image
export function removeProfileImageService() {
    return __awaiter(this, void 0, void 0, function () {
        var CustomerId_2, data, url, res, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    CustomerId_2 = getLoggedInRepDetailsFromSession().CustomerId;
                    return [4 /*yield*/, encryptData(JSON.stringify({ repId: CustomerId_2 }))];
                case 1:
                    data = _a.sent();
                    url = baseUrl + "?data=" + data + "&pageIndex=56";
                    return [4 /*yield*/, apiCallService(url, "", "POST")];
                case 2:
                    res = _a.sent();
                    if (res) {
                        return [2 /*return*/, true];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    displaySnackbarErrMsg();
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export function getB2BCompaniesService(params) {
    var _a, _b, _c, _d, _e, _f;
    return __awaiter(this, void 0, void 0, function () {
        var companyRequestModel, urlParams_1, url, serviceCallResponse, error_13;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 2, , 3]);
                    companyRequestModel = {
                        batchSize: (_a = params.batchSize) !== null && _a !== void 0 ? _a : 50,
                        searchQuery: (_b = params.searchQuery) !== null && _b !== void 0 ? _b : "",
                        isNextPage: (_c = params.isNextPage) !== null && _c !== void 0 ? _c : true,
                        endCursor: (_d = params.endCursor) !== null && _d !== void 0 ? _d : "",
                        startCursor: (_e = params.startCursor) !== null && _e !== void 0 ? _e : "",
                        isShowAllCustomer: (_f = params.isShowAllCustomer) !== null && _f !== void 0 ? _f : false,
                    };
                    urlParams_1 = new URLSearchParams();
                    urlParams_1.append("data", "56");
                    Object.entries(companyRequestModel).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        urlParams_1.append(key, String(value));
                    });
                    url = baseUrlWithCommonParams() + "&" + urlParams_1.toString();
                    return [4 /*yield*/, apiCallService(url, "", "GET")];
                case 1:
                    serviceCallResponse = _g.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_13 = _g.sent();
                    console.error("Error in getB2BCompaniesService:", error_13);
                    displaySnackbarErrMsg();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function getB2BCompanyByIdService(params) {
    var _a;
    return __awaiter(this, void 0, void 0, function () {
        var urlParams, url, serviceCallResponse, error_14;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    urlParams = new URLSearchParams();
                    urlParams.append("data", "57");
                    urlParams.append("companyId", (_a = params.companyId) !== null && _a !== void 0 ? _a : "");
                    url = baseUrlWithCommonParams() + "&" + urlParams.toString();
                    return [4 /*yield*/, apiCallService(url, "", "GET")];
                case 1:
                    serviceCallResponse = _b.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_14 = _b.sent();
                    console.error("Error in getB2BCompanyByIdService:", error_14);
                    displaySnackbarErrMsg();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function getAllCustomersService(params) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function () {
        var customerRequestModel, urlParams_2, url, serviceCallResponse, error_15;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    _f.trys.push([0, 2, , 3]);
                    customerRequestModel = {
                        isNextPage: (_a = params.isNextPage) !== null && _a !== void 0 ? _a : true,
                        endCursor: (_b = params.endCursor) !== null && _b !== void 0 ? _b : "",
                        startCursor: (_c = params.startCursor) !== null && _c !== void 0 ? _c : "",
                        searchQuery: (_d = params.searchString) !== null && _d !== void 0 ? _d : "",
                        isShowAllCustomer: (_e = params.isShowAllCustomer) !== null && _e !== void 0 ? _e : false,
                    };
                    urlParams_2 = new URLSearchParams();
                    urlParams_2.append("data", "51");
                    Object.entries(customerRequestModel).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        urlParams_2.append(key, String(value));
                    });
                    url = baseUrlWithCommonParams() + "&" + urlParams_2.toString();
                    return [4 /*yield*/, apiCallService(url, "", "GET")];
                case 1:
                    serviceCallResponse = _f.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_15 = _f.sent();
                    console.error("Error in getAllCustomersService:", error_15);
                    displaySnackbarErrMsg();
                    return [2 /*return*/, false];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export function getTerritoryReportService(startDate, endDate) {
    return __awaiter(this, void 0, void 0, function () {
        var url, body, serviceCallResponse, error_16;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 3, , 4]);
                    url = baseUrlWithCommonParams() + "&pageIndex=62";
                    return [4 /*yield*/, encryptData(JSON.stringify({ startDate: startDate, endDate: endDate }))];
                case 1:
                    body = _a.sent();
                    return [4 /*yield*/, apiCallService(url, body, "POST").then(function (data) { return data; })];
                case 2:
                    serviceCallResponse = _a.sent();
                    if (serviceCallResponse) {
                        return [2 /*return*/, serviceCallResponse];
                    }
                    else {
                        displaySnackbarErrMsg();
                        return [2 /*return*/, false];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_16 = _a.sent();
                    logClientRuntimeError("getTerritoryReportService", error_16);
                    displaySnackbarErrMsg();
                    return [2 /*return*/, false];
                case 4: return [2 /*return*/];
            }
        });
    });
}
